module.exports = __webpack_public_path__ + "static/media/oxfam.fd83154d.png";